import apiClient from './api';
import type {
  VersionDistributionResponse,
  DeviceUptimeResult,
  FleetUptimeResult,
  FleetHeartbeatResult,
  FleetMetricsTrendResult,
  FleetEventStatsResult,
  FleetHealthResult,
  EnrollmentGrowthResult,
  FleetEventType,
} from '../types';

export const analyticsService = {
  getVersionDistribution: async (type = 'agent'): Promise<VersionDistributionResponse> => {
    return apiClient.get<VersionDistributionResponse>(
      `/analytics/version-distribution?type=${encodeURIComponent(type)}`
    );
  },

	getFleetUptime: async (period = '7d'): Promise<FleetUptimeResult> => {
		return apiClient.get<FleetUptimeResult>(
      `/analytics/fleet-uptime?period=${encodeURIComponent(period)}`
    );
  },

  getFleetHeartbeat: async (period = '24h'): Promise<FleetHeartbeatResult> => {
    return apiClient.get<FleetHeartbeatResult>(
      `/analytics/fleet-heartbeat?period=${encodeURIComponent(period)}`
    );
  },

  getFleetTrends: async (period = '24h'): Promise<FleetMetricsTrendResult> => {
    return apiClient.get<FleetMetricsTrendResult>(
      `/analytics/fleet-trends?period=${encodeURIComponent(period)}`
    );
  },

  getFleetEvents: async (type: FleetEventType = 'boot', period = '24h'): Promise<FleetEventStatsResult> => {
    return apiClient.get<FleetEventStatsResult>(
      `/analytics/fleet-events?type=${encodeURIComponent(type)}&period=${encodeURIComponent(period)}`
    );
  },

  getFleetHealth: async (period = '24h'): Promise<FleetHealthResult> => {
    return apiClient.get<FleetHealthResult>(
      `/analytics/fleet-health?period=${encodeURIComponent(period)}`
    );
  },

  getEnrollmentGrowth: async (weeks = 12): Promise<EnrollmentGrowthResult> => {
    return apiClient.get<EnrollmentGrowthResult>(`/analytics/enrollment-growth?weeks=${weeks}`);
  },

  getDeviceUptime: async (deviceId: string, start?: string, end?: string): Promise<DeviceUptimeResult> => {
    const params = new URLSearchParams();
    if (start) params.set('start', start);
    if (end) params.set('end', end);
    const qs = params.toString();
    return apiClient.get<DeviceUptimeResult>(`/devices/${deviceId}/uptime${qs ? `?${qs}` : ''}`);
  },
};

export default analyticsService;
